import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import ScrapAgentService from '@/service/scrap-agent.service';

@Component({
  components: {},
})
export default class ModalAccessComponent extends Vue {
  @Prop(Boolean) readonly open!: boolean;
  isDeleteSuccess = false;
  @Prop({ type: Object, default: () => ({}) }) itemDelete!: any;
  @Inject('scrapAgentService')
  public scrapAgentService!: () => ScrapAgentService;

  @Watch('open', { immediate: true })
  onOpenChange(newVal: boolean) {
    this.isDeleteSuccess = false;
  }
  handleCloseModal() {
    this.$emit('modal:close', false);
  }
  handleCloseAndLoading() {
    this.$emit('modal:close', false);
  }
  async handleAccessDelete() {
    try {
      const userKey = JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
      console.log(this.itemDelete, 'this.itemdelete');
      const hasValidAgentAndDataSourceId = this.itemDelete.collections.some(account =>
        account.datasourceList.some(item => !!item.agentId?.trim() || !!item.dataSourceId?.trim())
      );
      const payload = {
        requestId: new Date().getTime().toString(),
        userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || '',
        bpId: this.itemDelete.collections[0].bpId,
        dataSourceAccount: [
          {
            bpId: this.itemDelete.collections[0].bpId,
            channelType: this.itemDelete.channelType,
            dataSources: this.itemDelete.collections[0].datasourceList,
          },
        ],
      };
      if (hasValidAgentAndDataSourceId) {
        const res = await this.scrapAgentService().deleteScrapAgent(payload);
      }
      this.isDeleteSuccess = true;
      this.$emit('modal:close', true);
      this.$bvToast.toast(`${this.$t('scrap-agent.toast.delete-scrap.messSuccess')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('scrap-agent.toast.success')}`,
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
      });
    } catch (err) {
      this.$bvToast.toast(`${this.$t('scrap-agent.toast.delete-scrap.messFail')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('scrap-agent.toast.error')}`,
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
      });
      console.log(err);
    }
  }
}
